import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgDelivereasy = function SvgDelivereasy(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M19.5 8.955v-.001a6.52 6.52 0 0 0-2-.304h-.003a6.433 6.433 0 0 0-1.998.304h-.001c-4.485 1.428-6.275 6.559-3.577 10.426 1.158 1.656 2.405 3.24 3.664 4.842a265.23 265.23 0 0 1 1.577 2.017v.001c.105.137.215.264.337.401.123-.137.232-.264.337-.4l.001-.002c.524-.68 1.052-1.35 1.577-2.017 1.26-1.601 2.506-3.186 3.663-4.842L19.502 8.955Zm0 0c4.486 1.427 6.276 6.558 3.578 10.425L19.5 8.955Zm-6.584 6.173c.038-2.59 2.183-4.514 4.819-4.45 2.433.055 4.405 2.162 4.344 4.604m-9.163-.154 8.513.138m-8.513-.138c-.034 2.5 1.986 4.586 4.494 4.648m-4.494-4.648 4.51 3.998m4.653-3.844-.65-.016m.65.016-.65-.016m.65.016c-.058 2.474-2.207 4.556-4.67 4.494m4.02-4.51c-.05 2.123-1.907 3.913-4.003 3.86m-.016.65.016-.65m-.016.65.016-.65",
      stroke: "currentColor",
      strokeWidth: 1.3
    }))
  }));
};
export default SvgDelivereasy;